module.exports = __webpack_public_path__ + "media/hyper/images/file-searching-c1222942fc292b9f937b5a0718e37e2d.svg";